module.exports = __webpack_public_path__ + "img/tn-stock-2.3a8a3d01.jpeg";